import { call, put, takeLatest } from "@redux-saga/core/effects";
import UploadFileService from "../../Services/RestApiManager/FileManager/UploadFileService";
import {
  DOWNLOADFILE_ACTION,
  FILE_ACTION,
  GETFILE_ACTION,
  errorDownloadFileAction,
  errorGetFileAction,
  errorUploadFileAction,
  responseDownloaloadFileAction,
  responseGetFileAction,
  responseUploadFileAction,
} from "./uploadFileActionCreator";
import LoginService from "../../Services/RestApiManager/LoginManager/LoginService";
import { downloadBase64AsFile, downloadBase64AsFile1 } from "../../helpers/Localstorage";

export function* uploadFileRequest(action) {
  try {
    const response = yield call(
      UploadFileService.shared.uploadFileRequest,
      action.data
    );
    
    // Handle profile image flag if present in the request
    if (action.data.isProfileImage) {
      // Pass the isProfileImage flag along with the response
      yield put(responseUploadFileAction({
        ...response,
        isProfileImage: true
      }));
    } else {
      yield put(responseUploadFileAction(response));
    }
  } catch (error) {
    yield put(errorUploadFileAction(error));
  }
}

export function* getFileRequest() {
  try {
    const response = yield call(LoginService.shared.backgroundImageRequest);
    yield put(responseGetFileAction(response));
  } catch (error) {
    yield put(errorGetFileAction(error));
  }
}

export function* downloadFileRequest(payload) {
  try {
    const response = yield call(
      UploadFileService.shared.downloadFileRequest,
      payload.data.id,
      payload.data.fileId,
      payload.data.action
    );
 
    if (payload.data.action === "download") {
      if (response) {
        let fileType = payload.data.fileName.split(".").pop().toLowerCase();
        let mimeType = fileType === "pdf" ? "application/pdf" : "image/jpeg";
        downloadBase64AsFile1(response.fileName, response.fileType, response.fileUrl);
        yield put(responseDownloaloadFileAction(response));
      }
    } else {
      yield put(responseDownloaloadFileAction(response));
    }
  } catch (error) {
    yield put(errorDownloadFileAction(error));
  }
}


export function* uploadFileWatcherSaga() {
  yield takeLatest(FILE_ACTION.REQUEST, uploadFileRequest);
  yield takeLatest(GETFILE_ACTION.REQUEST, getFileRequest);
  yield takeLatest(DOWNLOADFILE_ACTION.REQUEST, downloadFileRequest);
}
